export default __webpack_public_path__ + "static/media/ic_paypal_white.57f49b11.svg";